import React, { useState } from 'react';
import { Box, Typography, Tooltip, IconButton, Collapse } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useNavigate } from 'react-router';
import {
  TextFields as TextFieldsIcon,
  Image as ImageIcon,
  Videocam as VideocamIcon,
  Audiotrack as AudiotrackIcon,
  InsertDriveFile as InsertDriveFileIcon,
  TouchApp as TouchAppIcon,
  List as ListIcon,
  Contacts as ContactsIcon,
  ShoppingBag as ShoppingBagIcon,
  ViewModule as ViewModuleIcon,
  WhatsApp as WhatsAppIcon,
  AccountTree as AccountTreeIcon,
  LocationOn as LocationOnIcon,
  Rule as ConditionIcon,
  Height,
} from '@mui/icons-material';
import DescriptionIcon from '@mui/icons-material/Description';
import InfoIcon from '@mui/icons-material/Info';
import LinkIcon from '@mui/icons-material/Link';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { Overlay } from 'react-bootstrap';

const Sidebar = () => {
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState('basic');

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? '' : section);
  };

  const nodeTooltips = {
    text: 'Add a text message node. Use this to send a plain text message to the user, such as a greeting, information, or instructions.',
    image: 'Add an image node. Share visual content like pictures, infographics, or product images with the user.',
    video: 'Add a video node. Send engaging video content or tutorials directly to the user.',
    audio: 'Add an audio node. Share voice messages, audio clips, or other sound files with the user.',
    document: 'Add a document upload node. Provide downloadable resources such as PDFs, brochures, or manuals to the user.',
    button: 'Add a button node. Use buttons to offer quick-reply options or external link navigation within a WhatsApp template.',
    list: 'Add a list with options. Present a structured menu or list of choices for the user to select from.',
    intervention: 'Add a request intervention node. Alert a human operator to step in and assist the user with specific queries or issues.',
    catalog: 'Add a catalog node. Showcase a collection of products or services for users to browse directly within the chat.',
    product: 'Add a product node. Highlight an individual product from your catalog for detailed user interaction.',
    whatsAppFlow: 'Add a WhatsApp flow node. Configure a flow with ID, body text, and button types for interaction.',
    existingFlow: 'Add a flow node. Configure a flow with ID, body text, and button types for interaction.',
    address: 'Add a address node',
    // template: 'Add a template node. Select a pre-configured template for a quick flow interaction.',
    openAi: 'Add an OpenAI node. Configure an OpenAI-powered chat or interaction in your flow.',
   ctaUrl: 'Add a CTA URL node. Use this to add a call-to-action button with a custom URL and label.',
  //  knowledgeBase: 'Add a knowledge base node. Upload documents or files to power your chatbot with vector search capability.',
   conditional: 'Add a condition'

  };

  const basicNodes = [
    { icon: TextFieldsIcon, label: 'Text', type: 'text' },
    { icon: ImageIcon, label: 'Image + Text', type: 'image' },
    { icon: VideocamIcon, label: 'Video + Text', type: 'video' },
    { icon: AudiotrackIcon, label: 'Audio', type: 'audio' },
    { icon: InsertDriveFileIcon, label: 'Document + Text', type: 'document' },
    { icon: TouchAppIcon, label: 'Button', type: 'button' },
    { icon: ListIcon, label: 'List', type: 'list' },
     { icon: LinkIcon, label: 'CTA URL', type: 'ctaUrl' },
  ];

  const advancedNodes = [
    { icon: DescriptionIcon, label: 'OpenAI', type: 'openAi' }, 
    { icon: ContactsIcon, label: 'Intervention', type: 'intervention' },
    { icon: ViewModuleIcon, label: 'Catalog', type: 'catalog' },
    { icon: ShoppingBagIcon, label: 'Product', type: 'product' },
    { icon: WhatsAppIcon, label: 'WhatsApp Flow', type: 'whatsAppFlow' },
    { icon: AccountTreeIcon, label: 'Existing Flow', type: 'existingFlow' },
    { icon: LocationOnIcon, label: 'Address', type: 'address' },
    // { icon: DescriptionIcon, label: 'Template', type: 'template' }, 
    // { icon: MenuBookIcon, label: 'Knowledge Base', type: 'knowledgeBase' },
    { icon: ConditionIcon, label: 'Conditional', type: 'conditional' },

   
  ];

  return (
    <Box
      height="80vh"
      width="200px"
      borderRight="1px solid #e0e0e0"
      style={{
        backgroundColor: '#f9f9f9',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        boxShadow: '2px 0 5px rgba(0, 0, 0, 0.05)',
        padding: '10px',
        overflowY: 'hidden',
      }}
    >
      <Typography variant="h6" style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px', marginBottom: '10px', color: '#333' }}>
        <ArrowBackIcon onClick={() => navigate('/r/flow/list/')} style={{ cursor: 'pointer', marginRight: '8px' }} />
        Chatbot Builder
      </Typography>

      {/* Basic Nodes Section */}
      <Box display="flex" justifyContent="space-between" alignItems="center" style={{ padding: '5px 0' }}>
        <Typography variant="body1" style={{ fontWeight: 'bold', color: '#333' }}>Basic Nodes</Typography>
        <IconButton size="small" onClick={() => toggleSection('basic')}>
          {openSection === 'basic' ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={openSection === 'basic'} timeout="auto" unmountOnExit  sx={{minHeight:'58vh !important',overflowY:'auto',scrollbarWidth:'none'}}>
        {basicNodes.map((node) => (
          <SidebarNode key={node.type} node={node} tooltip={nodeTooltips[node.type]} />
        ))}
      </Collapse>

      {/* Advanced Nodes Section */}
      <Box display="flex" justifyContent="space-between" alignItems="center" style={{ padding: '5px 0' }}>
        <Typography variant="body1" style={{ fontWeight: 'bold', color: '#333' }}>Advanced Nodes</Typography>
        <IconButton size="small" onClick={() => toggleSection('advanced')}>
          {openSection === 'advanced' ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={openSection === 'advanced'} timeout="auto" unmountOnExit sx={{minHeight:'58vh !important',overflowY:'auto',scrollbarWidth:'none'}}>
        {advancedNodes.map((node) => (
          <SidebarNode key={node.type} node={node} tooltip={nodeTooltips[node.type]} />
        ))}
      </Collapse>
    </Box>
  );
};

const SidebarNode = ({ node, tooltip }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      style={{
        padding: '8px',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        height: '45px',
        marginBottom: '6px',
      }}
      draggable
      onDragStart={(e) => e.dataTransfer.setData('application/reactflow', node.type)}
    >
      <Box display="flex" alignItems="center">
        <node.icon style={{ fontSize: '16px', color: '#555', marginRight: '8px' }} />
        <Typography variant="body2" style={{ fontWeight: '500', color: '#333' }}>{node.label}</Typography>
      </Box>
      <Tooltip title={tooltip} placement="top" arrow>
        <IconButton size="small" style={{ color: '#888' }}>
          <InfoIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default Sidebar;


